import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { faChartColumn, faChevronRight, faLocationDot, faTag, faRulerCombined, faTruckFast, faFilter } from '@fortawesome/free-solid-svg-icons';
import { DayBookService } from 'src/app/share/services/day-book/day-book.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { SdexAdminService } from 'src/app/share/services/sdex/sdex-admin.service';

@Component({
  selector: 'app-day-book-sales',
  templateUrl: './day-book-sales.component.html',
  styleUrls: ['./day-book-sales.component.scss'],
  standalone: false
})
export class DayBookSalesComponent implements OnChanges, OnInit {
  protected readonly faChartColumn = faChartColumn;
  protected readonly faChevronRight = faChevronRight;
  protected readonly faLocationDot = faLocationDot;
  protected readonly faTag = faTag;
  protected readonly faRulerCombined = faRulerCombined;
  protected readonly faTruckFast = faTruckFast;
  protected readonly faFilter = faFilter;

  @ViewChild('salesModal') salesModalTemplate!: any;

  @Input() selectedDate: any;
  @Input() selectedBranch: string = '';
  @Input() branches: any[] = [];
  @Input() isBranchVisible: boolean = false;
  @Input() totalInvoices: number = 0

  salesBadgeValue: string = '';
  branchSales: any[] = [];
  brandSales: any[] = [];
  tyreSizeSales: any[] = [];
  vehicleSales: any[] = [];
  allSales: any[] = [];
  usersList: any[] = [];
  loader: boolean = false;
  errMsg: string = '';
  salesLoader: boolean = false;
  salesErrMsg: string = '';
  transactionTypeList = [
    { name: 'Sale to Customer', value: 'SoldToCustomer' },
    { name: 'Sale to Dealer', value: 'SoldToDealer' },
    { name: 'Service', value: 'hasService' },
    { name: 'Tyre Sales', value: 'hasStock' },
  ];
  filters: any = {
    tyreSize: '',
    tyreMake: '',
    service: '',
    company: '',
    tyreModel: '',
    createdBy: null,
    stockOutType: null,
  };
  showFilters: boolean = false;

  selectedVoucher: { url: any; name: any } = { url: '', name: '' };

  constructor(
    private readonly dayBookService: DayBookService,
    private readonly modalService: NgbModal,
    private readonly sanitizer: DomSanitizer,
    private readonly sdexAdminService: SdexAdminService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedDate'] || changes['selectedBranch']) {
      this.branchSales = [];
      this.brandSales = [];
      this.tyreSizeSales = [];
      this.vehicleSales = [];
      this.getSalesStats();
    }
  }

  ngOnInit(): void {
    this.getUsers();
  }


  getUsers() {
    this.sdexAdminService.getAllUsers({}).subscribe({
      next: (res: any) => {
        this.usersList = res.data || []
      }
    })
  }

  getSalesStats() {
    this.loader = true;
    this.errMsg = '';
    let params: any = {
      created_date: this.selectedDate
    };
    if (this.selectedBranch) {
      params.company = this.selectedBranch
    }
    this.dayBookService.getSalesStats(params)
    forkJoin({
      branch: this.dayBookService.getBranchSales(params),
      sale: this.dayBookService.getSalesStats(params)
    }).subscribe({
      next: (res: any) => {
        this.loader = false
        this.mapSalesResponse(res.sale.data || {})
        this.branchSales = (res.branch.data || []).slice(0, 5);
      },
      error: (err: any) => {
        this.loader = false;
        this.errMsg = "Failed to fetch sales data"
      }
    })
  }

  mapSalesResponse(data: any) {
    this.brandSales = (data.makeSales || []).slice(0, 5)
    this.tyreSizeSales = (data.sizeSales || []).slice(0, 5)
    this.vehicleSales = (data.categorySales || []).slice(0, 5)
  }

  viewAllSales(modalContent: any) {
    this.resetFilters();
    this.showFilters = false;
    this.getAllSales()
    this.modalService.open(modalContent, { size: 'xl', centered: true });
  }

  openSalesModalDirectly(type: string) {
    this.showFilters = false;
    this.resetFilters();
    if (type == 'services') {
      this.filters.stockOutType = 'hasService';
    } else if(type == 'tyres') {
      this.filters.stockOutType = 'hasStock'
    }
    this.getAllSales();
    this.modalService.open(this.salesModalTemplate, { size: 'xl', centered: true });
  }

  onRowClick(type: 'branch' | 'size' | 'brand', item: any) {
    this.resetFilters();    
    if (type === 'branch') {
      this.filters.company = item.companyId
    } else if (type === 'size') {
      this.filters.tyreSize = item.label || '';
    } else if (type === 'brand') {
      this.filters.tyreMake = item.label || '';
    }
    
    this.getAllSales();
    this.modalService.open(this.salesModalTemplate, { size: 'xl', centered: true });
  }

  viewVoucher(item: any, pdfModal: any) {
    if (item.invoice) {
      this.selectedVoucher.url = this.sanitizer.bypassSecurityTrustResourceUrl(item.invoice);
      this.selectedVoucher.name = item.invoiceNo;
      this.modalService.open(pdfModal, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
    }
  }

  getSalesParams() {
    let params: any = {
      created_date: this.selectedDate
    };
    if (this.selectedBranch) {
      params.company = this.selectedBranch;
    }
    if (this.filters.tyreSize) params.tyreSize = this.filters.tyreSize;
    if (this.filters.tyreMake) params.tyreMake = this.filters.tyreMake;
    if (this.filters.service) params.service = this.filters.service;
    if (this.filters.company) params.company = this.filters.company;
    if (this.filters.tyreModel) params.tyreModel = this.filters.tyreModel;
    if (this.filters.createdBy) params.createdBy = this.filters.createdBy;

    if (this.filters.stockOutType) {
      if (this.filters.stockOutType === 'hasService') {
        params.hasService = true;
      } else if (this.filters.stockOutType === 'hasStock') {
        params.hasStock = true;
      } else {
        params.stockOutType = this.filters.stockOutType;
      }
    }
    return params
  }

  getAllSales() {
    this.salesLoader = true;
    this.salesErrMsg = '';
    this.allSales = [];
    let params: any = this.getSalesParams()
    this.dayBookService.getAllSales(params).subscribe({
      next: (res: any) => {
        this.salesLoader = false;
        this.mapSalesListResponse(res.data || []);
      },
      error: (err: any) => {
        this.salesLoader = false;
        this.salesErrMsg = err?.error?.error?.message || "Failed to get data"
      }
    })
  }

  mapSalesListResponse(data: any) {
    if (!Array.isArray(data)) return;
    this.allSales = data.map((order: any) => {
      const stockItems = (order.stock || []).map((s: any) => {
        return {
          ...s,
          itemType: 'stock',
        };
      });

      const serviceItems = (order.serviceDetails || []).map((s: any) => {
        return {
          ...s,
          itemType: 'service',
          qty: null,
        };
      });

      const allRows = [...stockItems, ...serviceItems];
      return {
        ...order,
        allRows: allRows,
        stockCount: stockItems.length,
        serviceCount: serviceItems.length,
        totalRows: allRows.length || 1,
      };
    });
  }

  onChangeFilter() {
    if (this.salesLoader) return
    this.getAllSales();
  }

  resetFilters() {
    this.filters = {
      tyreSize: '',
      tyreMake: '',
      service: '',
      company: this.selectedBranch,
      createdBy: null,
      stockOutType: null,
    };
  }

}


